module.exports = __webpack_public_path__ + "img/ai-magic.9f94449d.svg";